import * as Colors from 'material-ui/styles/colors';
import { emphasize } from 'material-ui/utils/colorManipulator';
import {NAV_HEIGHT} from 'Layout/MyAccountLayout/dimensions';
export default {
  buttonStyle: {
    color: Colors.white,
    borderRadius: 0,
    lineHeight: '35px',
    minWidth: 'auto',
    height: NAV_HEIGHT,
    margin: 0,
    padding: 0,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
  },
  iconButtonStyle: {
    color: Colors.white,
    padding: '0 8px',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  homeIconStyle: {
    paddingLeft: '10px',
    top: '6px',
    position: 'relative',
    color: Colors.white
  },
  iconStyle: {
    position: 'relative',
    color: Colors.white
  },
  buttonProperties: {
    backgroundColor: Colors.grey700,
    hoverColor: emphasize(Colors.grey700)
  },
  separatorStyle: {
    top: 0,
    margin: 0,
    height: NAV_HEIGHT,
  },
  menuItemStyle: {
    textTransform: 'none',
    fontSize: '15px',
    padding: 0
  },
  centeredControls: {
    position: 'absolute',
    left: '50vw',
    transform: 'translateX(-50%)',
    display: 'block'
  },
  previewModeText: {
    color: Colors.white,
    height: `${NAV_HEIGHT}px`,
    lineHeight: `${NAV_HEIGHT}px`,
    verticalAlign: 'top'
  },
  primaryButtonProperties: {
    backgroundColor: Colors.lightGreen700,
    hoverColor: emphasize(Colors.lightGreen700)
  },
};
